import { Component, Inject} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { Batch } from 'src/app/assabil-kernel/models/entities/master-data/batch';

@Component({
    selector: 'batch-lov',
    templateUrl: './batch-lov.component.html',
    styleUrls: ['./batch-lov.component.scss']
})


export class BatchLovComponent extends GenericLovComponent {
  

//----------------------------------------------------
batchs          : Batch[] = [];
sourceBatchs    : Batch[] = [];
selectedBatchs  : Batch[] = [];
dual              : boolean = false;
returnList        : boolean = false;  
// ---------------------------------------------------

columns = [
    { prop: 'product.codeName',     name: 'Produit'},
    { prop: 'batchCode',            name: 'Lot'},
    { prop: 'expiringDate',         name: 'Date Exipation' },
    { prop: 'description',          name: 'description' }
]

//----------------------------------------------------------------------------------------------------------------
constructor(
    public dialogRef: MatDialogRef<BatchLovComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected userService       : UserService,
    protected router            : Router,
    protected location          : Location,
    protected controlService    : ControlTablesService) {
        super();
        if (data){
            this.batchs    = data.batchs;
            this.dual      = data.dual;
            this.returnList= data.returnList;
        }
    }
//----------------------------------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------------------------------- 
ngOnInit() {
    super.ngOnInit();
    this.setData();
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
loadData() {
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
setData() {
    if (! this.batchs ) return;
    this.sourceBatchs  = [...this.batchs];
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
addToSelected(batch : Batch){
    this.selectedBatchs.push(batch);
    this.sourceBatchs.splice(this.sourceBatchs.indexOf(batch),1)
    this.sourceBatchs   = [...this.sourceBatchs]
    this.selectedBatchs = [...this.selectedBatchs]
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
removeFromSelected(batch : Batch){
    this.sourceBatchs.push(batch);
    this.selectedBatchs.splice(this.selectedBatchs.indexOf(batch),1)
    this.sourceBatchs     = [...this.sourceBatchs]
    this.selectedBatchs = [...this.selectedBatchs]
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
addAll(){
    this.sourceBatchs   = [];
    this.selectedBatchs = [...this.batchs];
}
removeAll(){
    this.sourceBatchs   = [...this.batchs];
    this.selectedBatchs = [];
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
closeModal(batch : Batch){
    if (this.returnList || this.dual) {
        let result = {batchs : null, batch : null, selectedBatchs : null};
        result.batch             = batch;
        result.selectedBatchs    = this.selectedBatchs;
        result.batchs            = this.batchs;
        this.dialogRef.close(result);
    } else {
        this.dialogRef.close(batch);
    }
}
 //----------------------------------------------------------------------------------------------------------------

}


